/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetOrganizationalUnitDto,
    GetOrganizationalUnitDtoFromJSON,
    GetOrganizationalUnitDtoFromJSONTyped,
    GetOrganizationalUnitDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetInspectionPlanDto
 */
export interface GetInspectionPlanDto {
    /**
     * 
     * @type {string}
     * @memberof GetInspectionPlanDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetInspectionPlanDto
     */
    year: number;
    /**
     * 
     * @type {number}
     * @memberof GetInspectionPlanDto
     */
    numberOfProducts: number;
    /**
     * 
     * @type {number}
     * @memberof GetInspectionPlanDto
     */
    numberOfProductsCpr: number;
    /**
     * 
     * @type {number}
     * @memberof GetInspectionPlanDto
     */
    numberOfInspections: number;
    /**
     * 
     * @type {number}
     * @memberof GetInspectionPlanDto
     */
    numberOfInspectionsCpr: number;
    /**
     * 
     * @type {number}
     * @memberof GetInspectionPlanDto
     */
    numberOfStaffs: number;
    /**
     * 
     * @type {string}
     * @memberof GetInspectionPlanDto
     */
    comments: string;
    /**
     * 
     * @type {string}
     * @memberof GetInspectionPlanDto
     */
    status: GetInspectionPlanDtoStatusEnum;
    /**
     * 
     * @type {GetOrganizationalUnitDto}
     * @memberof GetInspectionPlanDto
     */
    organizationalUnit: GetOrganizationalUnitDto;
}

export function GetInspectionPlanDtoFromJSON(json: any): GetInspectionPlanDto {
    return GetInspectionPlanDtoFromJSONTyped(json, false);
}

export function GetInspectionPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInspectionPlanDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'year': json['year'],
        'numberOfProducts': json['numberOfProducts'],
        'numberOfProductsCpr': json['numberOfProductsCpr'],
        'numberOfInspections': json['numberOfInspections'],
        'numberOfInspectionsCpr': json['numberOfInspectionsCpr'],
        'numberOfStaffs': json['numberOfStaffs'],
        'comments': json['comments'],
        'status': json['status'],
        'organizationalUnit': GetOrganizationalUnitDtoFromJSON(json['organizationalUnit']),
    };
}

export function GetInspectionPlanDtoToJSON(value?: GetInspectionPlanDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'year': value.year,
        'numberOfProducts': value.numberOfProducts,
        'numberOfProductsCpr': value.numberOfProductsCpr,
        'numberOfInspections': value.numberOfInspections,
        'numberOfInspectionsCpr': value.numberOfInspectionsCpr,
        'numberOfStaffs': value.numberOfStaffs,
        'comments': value.comments,
        'status': value.status,
        'organizationalUnit': GetOrganizationalUnitDtoToJSON(value.organizationalUnit),
    };
}

/**
* @export
* @enum {string}
*/
export enum GetInspectionPlanDtoStatusEnum {
    Niezatwierdzony = 'niezatwierdzony',
    ZatwierdzonyPrzezWINB = 'zatwierdzony przez WINB',
    ZatwierdzonyPrzezGINB = 'zatwierdzony przez GINB'
}


